import clsx from 'clsx';
import { type ChangeEvent, useCallback, useState } from 'react';

import { useSearch } from '~extension/icon-library/context/Search';
import { SearchIcon } from '../../icons/SearchIcon';
import { Categories } from './Categories';
import { IconCount } from './Counter';

export const SearchBar = () => {
  const [hasFocus, setHasFocus] = useState<boolean>(false);
  const { query, setQuery } = useSearch();
  const hasQuery = query && query.length > 0;

  const handleOnFocus = () => setHasFocus(true);
  const handleOnBlur = () => setHasFocus(false);
  const handleOnChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const value = event.currentTarget.value;
      setQuery(value);
    },
    [setQuery],
  );

  return (
    <div className="icon-library--searchbar-wrapper box-border p-2 w-full z-10 bg-gray">
      <div
        className={clsx(
          'icon-library--searchbar',
          'font-sans bg-white flex items-center h-10 px-2 transition-all',
          hasFocus || hasQuery ? 'shadow-md' : 'shadow-sm',
        )}
      >
        <div className="icon-library--searchbar-icon h-8 overflow-hidden w-8">
          <SearchIcon />
        </div>
        <input
          className="icon-library--searchbar-input appearance-none border-none bg-none cursor-text flex-grow text-base my-0 mx-2 min-w-0 p-0 text-current normal-case"
          type="text"
          placeholder="Search icons..."
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          onChange={handleOnChange}
          value={query}
        />
        <IconCount />
      </div>
      <Categories />
    </div>
  );
};
